// Branding
export const BRAND_NAME = 'Raya Software Solutions';

// Registered entity & statutory identifiers
export const LEGAL_ENTITY_NAME = 'Raya Solution & Company';
export const REGISTERED_ADDRESS = 'A-504, Eastface Building, Iscon Ambli Road, Ambli, Ahmedabad - 380058, Gujarat, India';

// One phone number, two shapes: CONTACT_PHONE is what tel: links dial,
// CONTACT_PHONE_DISPLAY is what people read.
export const CONTACT_PHONE = '+917859907534';
export const CONTACT_PHONE_DISPLAY = '+91 78599 07534';
export const CONTACT_EMAIL = 'info@rayasolutions.in';
export const GST_NUMBER = '24ABKFR3833P1ZN';

// D-U-N-S® Registered — profile key issued by Dun & Bradstreet.
// The seal links to the live D&B profile; the QR encodes the same profile.
export const DUNS_NUMBER = '30-751-8599';
export const DUNS_PROFILE_URL = 'https://dunsregistered.dnb.com/DunsRegisteredProfileAnywhere.aspx?Key1=3205247&PaArea=Email';

// Mobile apps.
// Each store has an *_AVAILABLE flag: when false the footer renders the badge
// in a "coming soon" state instead of linking out, so an unpublished listing
// never sends anyone to a dead store page.
export const PLAY_STORE_AVAILABLE = true;
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.raya.mobile';

// Raya ERP on the App Store (bundle id in.rayasolutions.erp). APP_STORE_ID is
// the numeric id from the listing URL; it also drives the Smart App Banner
// meta tag in public/index.html, so keep the two in step.
export const APP_STORE_AVAILABLE = true;
export const APP_STORE_ID = '6815593677';
export const APP_STORE_URL = `https://apps.apple.com/app/raya-erp/id${APP_STORE_ID}`;

// API Endpoints
export const API_BASE_URL = process.env.REACT_APP_IDS_API_BASE_URL;
export const API_ACCOUNT_REGISTER_ENDPOINT = '/RayaAccountManagement/Register';
export const API_AUTH_ENDPOINT = '/Auth';
export const API_CREDENTIALS_ENDPOINT = '/Credentials';
export const API_RESET_PASSWORD = '/ResetPassword';
export const API_AUTH_RENEW_TOKEN = '/RenewSession';
export const API_VERIFY_MFA_ENDPOINT = '/verify-mfa';
export const API_FORGOT_PASSWORD = '/forgot-password';

// URIs
export const WEBSITE_URI = process.env.REACT_APP_WEBSITE_URL;
export const DASHBOARD_APP_URI = process.env.REACT_APP_DASHBOARD_URL;
export const BI_APP_URI = process.env.REACT_APP_BI_URL;

// domains
export const DOMAIN = process.env.DOMAIN;

// Claims
export const TOKEN_EMAIL_CLAIMS = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress';
export const TOKEN_ACCOUNT_NAME_CLAIMS = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/windowsaccountname';
export const TOKEN_USER_ROLE = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';
export const TOKEN_USER_GIVEN_NAME = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname';

// Colors
export const PRIMARY_COLOR = '#007bff';
export const SECONDARY_COLOR = '#6c757d';

// Messages
export const ERROR_MESSAGE = 'An error occurred. Please try again later.';

// Industries offered at sign-up. The label is stored as-is on the account, and
// raya-api-ids applies an industry preset (e.g. "Logistics & Delivery" switches on
// the Fleet module) — keep these strings in sync with IndustryPresets there.
export const SIGNUP_INDUSTRIES = [
  'Manufacturing', 'Trading', 'Logistics & Delivery', 'Jewelry', 'Healthcare', 'Retail', 'Services', 'Other',
];

// User Roles
export const USER_ROLES = {
  ADMIN: 'admin',
  USER: 'user',
};
